import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
// DS1.10.5
import React, { useCallback } from 'react';
import c from 'classnames';
import { useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import PopperPositionedPopover from '../../../popper/PopperPositionedPopover';
import { usePopoverOnInteraction } from '../../../popper/hooks/usePopoverOnInteraction';
import PopoverWrapper from '../../../popper/PopoverWrapper';
import s from './CustomTooltip.scss';
const CustomTooltip = (_param)=>{
    var { content , children , width , forceVisible =false , className  } = _param, rest = _object_without_properties(_param, [
        "content",
        "children",
        "width",
        "forceVisible",
        "className"
    ]);
    const { isVisible , onClick , onMouseEnter , onMouseLeave , onClose  } = usePopoverOnInteraction({
        listenOnClicks: true,
        listenOnHover: true
    });
    const reverseTheme = useReverseTheme();
    const renderPopover = useCallback(({ effectivePlacement , effectiveSecondaryPlacement , rootRef , arrowRef , contentStyle , arrowStyle , contentAttributes , arrowAttributes , updatePositioning ,  })=>/*#__PURE__*/ React.createElement(PopoverWrapper, {
            contentClassName: s['popover-wrapper'],
            width: width,
            onClickOutside: onClose,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            effectivePlacement: effectivePlacement,
            effectiveSecondaryPlacement: effectiveSecondaryPlacement,
            rootRef: rootRef,
            arrowRef: arrowRef,
            contentStyle: contentStyle,
            arrowStyle: arrowStyle,
            contentAttributes: contentAttributes,
            arrowAttributes: arrowAttributes,
            updatePositioning: updatePositioning,
            forceTheme: reverseTheme
        }, content), [
        width,
        content,
        onMouseEnter,
        onMouseLeave,
        onClose,
        reverseTheme
    ]);
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, _extends({
        isVisible: isVisible || forceVisible,
        onReferenceClick: onClick,
        onReferenceMouseEnter: onMouseEnter,
        onReferenceMouseLeave: onMouseLeave,
        className: c(s['root'], className),
        renderPopover: renderPopover
    }, rest), children);
};
CustomTooltip.displayName = 'CustomTooltip';
export default CustomTooltip;
